import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useAuth, useGrid, useModal, useResource } from "@/comn/hooks";
import { BASE, APIS, SCHEMA_FORM_CSLDR_TIN_SRCH, SCHEMA_GRID_DSLDR_TIN } from "./services/ComnCdService";
import { Link } from "react-router-dom";
export const CsldrTinList = (props: any) => {
    const pgeUid = "csldrTinList";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "OSC0159" }],
    });

    const form = {
        csldrTinSrch: useForm({
            defaultSchema: SCHEMA_FORM_CSLDR_TIN_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        csldrTinList: useGrid({
            defaultSchema: SCHEMA_GRID_DSLDR_TIN,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getcsldrTinList: useFetch({
            api: (page = grid.csldrTinList.page) => {
                return APIS.getCsldrTinLst(form.csldrTinSrch.getValues(), page, grid.csldrTinList.size);
            },
            enabled: comnUtils.isEmpty(form.csldrTinSrch.errors) && form.csldrTinSrch.isSubmitted,
            key: [grid.csldrTinList.page, grid.csldrTinList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.csldrTinSrch.getValues(),
                    page: grid.csldrTinList.page,
                    size: grid.csldrTinList.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.csldrTinSrch.handleSubmit(
                () => {
                    grid.csldrTinList.setPage(0);
                    fetch.getcsldrTinList.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.csldrTinList.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.osc.00084" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_CsldrTinLst: {
            cell: {
                csldrTin: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: rowValues.csldrTin, label: rowValues.csldrNm, addr: rowValues.csldrAddr });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
    }, []);

    return (
        <Page title={t("T_UCR_NO_LIST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.csldrTinSrch.schema.srchCsldrTin}></Group.Control>
                                <Group.Control {...form.csldrTinSrch.schema.srchCsldrNm}></Group.Control>
                            </Group.Row>
                            <Group.Row>
                                <Group.Control {...form.csldrTinSrch.schema.srchCsldrAddr}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.csldrTinSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.csldrTinList.grid}
                            data={fetch.getcsldrTinList.data?.csldrList}
                            render={render.grid_CsldrTinLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
